import { render, staticRenderFns } from "./declarationList.vue?vue&type=template&id=dca4305a&scoped=true&"
import script from "./declarationList.vue?vue&type=script&lang=js&"
export * from "./declarationList.vue?vue&type=script&lang=js&"
import style0 from "./declarationList.vue?vue&type=style&index=0&id=dca4305a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca4305a",
  null
  
)

export default component.exports